// extracted by mini-css-extract-plugin
export default {"outView":"CaseItemNode_outView__92bOK","imgView":"CaseItemNode_imgView__Np36x","swiperText":"CaseItemNode_swiperText__ZSlWw"};